/**
 * Platform Detection Utility
 * Detects whether the app is running in Electron, Android (Capacitor), or Web
 */

import { Capacitor } from '@capacitor/core';

/**
 * Check if running in Electron environment
 * @returns {boolean}
 */
export function isElectron() {
    return typeof window !== 'undefined' && window.electronBridge !== undefined;
}

/**
 * Check if running in Android Capacitor environment
 * @returns {boolean}
 */
export function isAndroid() {
    try {
        return Capacitor?.isNativePlatform?.() === true && Capacitor?.getPlatform?.() === 'android';
    } catch (error) {
        return false;
    }
}

/**
 * Check if running in iOS Capacitor environment
 * @returns {boolean}
 */
export function isIOS() {
    try {
        return Capacitor?.isNativePlatform?.() === true && Capacitor?.getPlatform?.() === 'ios';
    } catch (error) {
        return false;
    }
}

/**
 * Check if running in web browser
 * @returns {boolean}
 */
export function isWeb() {
    return !isElectron() && !isAndroid() && !isIOS();
}

/**
 * Get current platform
 * @returns {'electron'|'android'|'ios'|'web'}
 */
export function getPlatform() {
    if (isElectron()) return 'electron';
    if (isAndroid()) return 'android';
    if (isIOS()) return 'ios';
    return 'web';
}

export default {
    isElectron,
    isAndroid,
    isIOS,
    isWeb,
    getPlatform
};
